import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { UtilService } from 'src/app/common/services/util/util.service';

@Component({
  standalone: true,
  selector: 'app-avatar-generator',
  templateUrl: './avatar-generator.component.html',
  styleUrls: ['./avatar-generator.component.scss'],
  imports: [CommonModule, AvatarModule]
})
export class AvatarGeneratorComponent implements OnInit, OnChanges {
  @Input()
  public photoUrl!: string;

  @Input()
  public name!: string;

  @Input()
  public circleSize!: 'normal' | 'large' | 'xlarge';

  @Input()
  public initialsSize!: string;

  @Input()
  public circleColor!: string;

  @Input()
  public showName = false;

  @Input() icon = '';

  public showInitials = false;
  public initials!: string;
  constructor(public utilService: UtilService) {}

  ngOnInit(): void {
    if (!this.photoUrl) {
      this.showInitials = true;
      this.createInitials();
    }
  }
  ngOnChanges(): void {
    if (!this.photoUrl) {
      this.showInitials = true;
      this.createInitials();
    }
  }

  private createInitials(): void {
    this.initials = this.utilService.createInitials(this.name);
  }
}
